import { CatalogueItem } from 'components/organisms/AdminPanelForm/EmploymentSection/ContractTypeSelect';

import { catalogoLenguage } from './dictionaries';

export function mapCatalogueItems(catalogue?: CatalogueItem[]) {
  const mappedList = catalogue?.map((Results: CatalogueItem) => {
    const ISO = Results.externalCode.split(catalogoLenguage.line);
    const spanishFormat = `${Results.label_es_ES}${catalogoLenguage.line}${ISO[0]}`;

    return {
      value: spanishFormat,
      label: spanishFormat,
    };
  });

  return mappedList ?? [];
}
